export const styles = {
  fullButton: {
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'start',
    gap: '16px',
    textAlign: 'start',
    whiteSpace: 'pre-line',
    backgroundColor: 'primary100',
    ':hover': {
      backgroundColor: 'primary200',
    },
    transition: 'all 250ms ease',
    py: ['20px', null, null, null, '50px'],
    px: ['16px', null, null, null, '20px'],
    width: ['100%', null, null, null, '300px'],
    height: '100%',
    cursor: 'pointer',
    '& h6': {
      fontSize: '16px',
    },
  },
  arrowWrapper: {
    position: 'absolute',
    bottom: [null, '21px', null, null, '52px'],
    height: '20px',
    left: '180px',
  },
  arrow: { rotate: '180deg' },
};
